import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ConfigService, UserTeam} from '@q9elements/ui-kit/common';

import {TAB_TYPES} from '../../../../spaces/models/spaces.interface';

@Injectable({
  providedIn: 'root'
})
export class SpaceNavigationDaoService {
  constructor(private http: HttpClient) {}

  public getSpacesList() {
    const url = `${ConfigService.environment.API_ENDPOINT}/organizations`;

    return this.http.get<UserTeam[]>(url, {params: {type: TAB_TYPES.MY}});
  }
}
